import 'tailwindcss/tailwind.css';

const Pdf = () => {
  return (
    <div className="bg-cover bg-center bg-no-repeat bg-fixed bg-verde3">
      <div className="p-8 w-full max-w-screen-lg mx-auto rounded-lg transition-transform duration-1000 ease-in-out">
        <div className="text-center">
          <h2 className="mt-14 mb-14 text-6xl text-verde1 font-bold font-allura">¡Los Esperamos!</h2>
        </div>
        
          <div  className="mt-14 text-verde1 text-center font-allura">
          <a 
            href="https://www.instagram.com/invitacionescyc/" // Reemplaza "tu_usuario" con tu nombre de usuario de Instagram
            target="_blank" // Esto abrirá el enlace en una nueva pestaña
            rel="noopener noreferrer" // Seguridad para evitar ataques
          >
              <span >
          Creado por cycInvitaciones  </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Pdf;
